import React, { useState } from "react";
import styled, { css } from 'styled-components';
import 'react-dropdown/style.css';
import Button from "../Shared/Button";
import { useHistory } from 'react-router-dom'
import {UseAppSelector} from "../../redux/configure-store";
import {
    getParticipantConsentData,
    getSelectedPlan,
    getOnlineStatements,
    getPaperlessStatement,
    getIsPlanNonQualified,
    getPaperlessPlanFeeDisclosures,
    getPaperlessPlanLegalNotices,
    getPaperlessProxyStatement,
    getDailyPrices,
    getMonthlyPerformance,
    getTracPlan,
    getIsParticipantTerminated,
    getIsSempraPlan,
    getIsSempraActivePlanNameOlaMsg,
    getIsSempraTerminatedPlanNameOlaMsg,
} from "../../redux/profile/selectors";
const StyledProfileInfo = styled.div`
  margin-top: 24px;
  flex-grow: 0;
  padding: 32px 40px;
  background-color: #fff;
  @media (max-width: 768px) {
    padding: 32px 24px;
  }
  @media (max-width: 640px) {
    padding: 24px;
  }
  @media only screen and (max-width: 480px) {
    margin-top: 16px;
  }
`;

const HeaderText = styled.div`
  color: #3b4b59;
  border-bottom: 1px solid #bec3c8;
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  font-weight: var(--beacon-font-weight-bold);
  font-size: 24px;
  line-height: 1.33;
  letter-spacing: 0.03px;
  padding-bottom: 8px;
  display: flex;
  justify-content: space-between;
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const SubHeaderText = styled.div`
  color: #3b4b59;
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  font-weight: var(--beacon-font-weight-bold);
  font-size: 20px;
  padding-top: 24px;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const StyledContainer = styled.div`
  padding: 0 8px;
`;

const StyledTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.02px;
  color: #3b4b59;
  border-bottom: 1px solid #e9ebed;
  :last-child {
    border-bottom: none;
  }
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;
const TextAlertsSection = styled.div`

`;

const StyledLinkContainer = styled.div`
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  font-weight: var(--beacon-font-weight-bold);
  display: flex;
  justify-content: space-between;
  margin-left: 16px;
  align-items: center;
`;

const StyledTitle = styled.div`
  width:85%;
  font-family: var(--beacon-font-families-nimbus-sans-novus);
`;

const StyledProxyTitle = styled.div`
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  @media(max-width: 1024px){
    width: 160px;
  }
`;

const StyledValue = styled.div`
  font-family: var(--beacon-font-families-nimbus-sans-novus);
`;

export const PreferencesCard = () => {
    const { push } = useHistory();
    const getStatus = (participantConsent: any, type : string) => {
        return participantConsent?.find((consent: any)=> consent.consentType === type)?.consentIndicator;
    }

    const getSempraActiveStatus = (participantConsent: any, type : string) => {
        const consentType =  (participantConsent?.find((consent: any)=> consent.consentType === type)?.consentIndicator);
        if(consentType === null || consentType === undefined)
            return true;
        return consentType;
    }

    const selectedPlan = UseAppSelector(getSelectedPlan);
    const planNumber = selectedPlan.value;
    const onlineStatements = UseAppSelector(getOnlineStatements);
    const paperlessStatement = UseAppSelector(getPaperlessStatement);
    const tracPlan = UseAppSelector(getTracPlan);
    const paperlessPlanFeeDisclosures = UseAppSelector(getPaperlessPlanFeeDisclosures);
    const paperlessPlanLegalNotices = UseAppSelector(getPaperlessPlanLegalNotices);
    const paperlessProxyStatement = UseAppSelector(getPaperlessProxyStatement);
    const dailyPrices = UseAppSelector(getDailyPrices);
    const monthlyPerformance = UseAppSelector(getMonthlyPerformance);
    const isPlanNonQualified = UseAppSelector(getIsPlanNonQualified);
    const participantConsents = UseAppSelector(getParticipantConsentData);
    const isTerminatedUser = UseAppSelector(getIsParticipantTerminated);
    const profileAlertStatus = getStatus(participantConsents, "52");
    const transactionalAlertStatus = getStatus(participantConsents, "51");
    const statementsStatus = getStatus(participantConsents, "5");
    const eConfirmStatus = getStatus(participantConsents, "28");
    const disclosureStatus = getStatus(participantConsents, "33");
    const noticeStatus = getStatus(participantConsents, "35");
    const proxyNoticesStatus = getStatus(participantConsents, "34");
    const tipsResourcesStatus = getStatus(participantConsents, "25");
    const dailyPriceStatus = getStatus(participantConsents, "23");
    const monthlyPerformanceStatus = getStatus(participantConsents, "24");
    const withdrawalStatus = getStatus(participantConsents, "30");
    const sempraActiveDeliveryOptionStatus = getSempraActiveStatus(participantConsents,"57");
    const sempraTerminatedDeliveryOptionStatus = getStatus(participantConsents,"58");
    const excludedPlanNumbers = ["999995","104600","105292","250919"];

    const isSempraPlan = UseAppSelector(getIsSempraPlan);
    const sempraActiveDeliveryOptionLabel = UseAppSelector(getIsSempraActivePlanNameOlaMsg)?.replace('(While Employed)','');
    const sempraTerminatedDeliveryOptionLabel = UseAppSelector(getIsSempraTerminatedPlanNameOlaMsg)?.replace('(After Employment Ends)','');
    const showSempraActiveDeliveryOptionLabel = isSempraPlan && !isTerminatedUser && sempraActiveDeliveryOptionLabel && (sempraActiveDeliveryOptionLabel?.trim()!=="");
    const showSempraTerminatedDeliveryOptionLabel = isSempraPlan && sempraTerminatedDeliveryOptionLabel && (sempraTerminatedDeliveryOptionLabel?.trim()!=="")
    const showEConfirm = !excludedPlanNumbers.includes(planNumber) && !tracPlan;
    const showTextAlerts = !tracPlan && !isPlanNonQualified;
    const statusIndicatorOn = 'On';
    const statusIndicatorOff = 'Off';

    return (
        <StyledProfileInfo>
            <HeaderText >
                Preferences
                {/*<StyledLink tabIndex={0} onClick={this.showDollarValueModal} onKeyPress={this.handleKeyPress}>*/}
                {/*    <StyledInfoIcon src={ToolTip} alt="tooltip icon" />*/}
                {/*</StyledLink>*/}
                <StyledLinkContainer>
                        <Button variant="tertiary" isIcon={true} onBeaconClick={() => push('/workplace/en/participant/profile/index/preference.html')} buttonTitle="Edit"/>
                </StyledLinkContainer>
            </HeaderText>
            {showTextAlerts &&
                <TextAlertsSection>
                    <SubHeaderText>
                        Text Alerts
                    </SubHeaderText>

                    <StyledContainer>
                        <StyledTitleContainer>
                            <StyledTitle>Profile Change Alerts</StyledTitle>
                            <StyledValue>{profileAlertStatus ? statusIndicatorOn : statusIndicatorOff}</StyledValue>
                        </StyledTitleContainer>
                        <StyledTitleContainer>
                            <StyledTitle>Transactional Alerts</StyledTitle>
                            <StyledValue>{transactionalAlertStatus ? statusIndicatorOn : statusIndicatorOff}</StyledValue>
                        </StyledTitleContainer>
                    </StyledContainer>
                </TextAlertsSection>
            }
                <SubHeaderText>
                    Paperless Options
                </SubHeaderText>
                <StyledContainer>
                    {(onlineStatements && paperlessStatement) &&
                        <StyledTitleContainer>
                            <StyledTitle>Statements</StyledTitle>
                            <StyledValue>{statementsStatus ? statusIndicatorOn : statusIndicatorOff}</StyledValue>
                        </StyledTitleContainer>}
                    {showEConfirm &&
                        <StyledTitleContainer>
                            <StyledTitle>Confirmation & Prospectuses</StyledTitle>
                            <StyledValue>{eConfirmStatus ? statusIndicatorOn : statusIndicatorOff}</StyledValue>
                        </StyledTitleContainer>}
                    {paperlessPlanFeeDisclosures &&
                        <StyledTitleContainer>
                            <StyledTitle>Disclosures</StyledTitle>
                            <StyledValue>{disclosureStatus ? statusIndicatorOn : statusIndicatorOff}</StyledValue>
                        </StyledTitleContainer>}
                    {paperlessPlanLegalNotices &&
                        <StyledTitleContainer>
                            <StyledTitle>Notices</StyledTitle>
                            <StyledValue>{noticeStatus ? statusIndicatorOff : statusIndicatorOn}</StyledValue>
                        </StyledTitleContainer>}
                    {(!tracPlan && paperlessProxyStatement) &&
                        <StyledTitleContainer>
                            <StyledProxyTitle>Proxy Notices (Employer Stock)</StyledProxyTitle>
                            <StyledValue>{proxyNoticesStatus ? statusIndicatorOn : statusIndicatorOff}</StyledValue>
                        </StyledTitleContainer>}
                    {showSempraActiveDeliveryOptionLabel &&
                        <StyledTitleContainer>
                            <StyledTitle>{sempraActiveDeliveryOptionLabel}<br/>(While Employed)</StyledTitle>
                            <StyledValue>{sempraActiveDeliveryOptionStatus ? statusIndicatorOn : statusIndicatorOff}</StyledValue>
                        </StyledTitleContainer>}
                    {showSempraTerminatedDeliveryOptionLabel &&
                        <StyledTitleContainer>
                            <StyledTitle>{sempraTerminatedDeliveryOptionLabel}<br/>(After Employment Ends)</StyledTitle>
                            <StyledValue>{sempraTerminatedDeliveryOptionStatus ? statusIndicatorOn : statusIndicatorOff}</StyledValue>
                        </StyledTitleContainer>}
                </StyledContainer>

                <SubHeaderText>
                    Email Subscriptions
                </SubHeaderText>
                <StyledContainer>
                    <StyledTitleContainer>
                        <StyledTitle>Tips & Resources</StyledTitle>
                        <StyledValue>{tipsResourcesStatus ? statusIndicatorOn : statusIndicatorOff}</StyledValue>
                    </StyledTitleContainer>
                    {dailyPrices &&
                        <StyledTitleContainer>
                            <StyledTitle>Daily Prices</StyledTitle>
                            <StyledValue>{dailyPriceStatus ? statusIndicatorOn : statusIndicatorOff}</StyledValue>
                        </StyledTitleContainer>
                    }
                    {monthlyPerformance &&
                        <StyledTitleContainer>
                            <StyledTitle>Monthly Performance</StyledTitle>
                            <StyledValue>{monthlyPerformanceStatus ? statusIndicatorOn : statusIndicatorOff}</StyledValue>
                        </StyledTitleContainer>
                    }
                    {(!tracPlan && !isPlanNonQualified) &&
                        <StyledTitleContainer>
                            <StyledTitle>Withdrawals</StyledTitle>
                            <StyledValue>{withdrawalStatus ? statusIndicatorOn : statusIndicatorOff}</StyledValue>
                        </StyledTitleContainer>}
                </StyledContainer>
        </StyledProfileInfo>
    );
};
